import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/core/store/store'

const licensesDeviceSerial = (state: RootState) => state.licenseVersionsReducer
export const licensesDeviceSerialSelector = createSelector(
  licensesDeviceSerial,
  licenseVersionsReducer => licenseVersionsReducer.licensesDeviceSerial,
)

const licenseVersion = (state: RootState) => state.licenseVersionsReducer
export const licenseVersionSelector = createSelector(
  licenseVersion,
  licenseVersionsReducer => licenseVersionsReducer.licenseVersion,
)

const prices = (state: RootState) => state.licenseVersionsReducer
export const pricesSelector = createSelector(
  prices,
  licenseVersionsReducer => licenseVersionsReducer.prices,
)
